export const locale = {
  lang: 'en',
  data: {
    legalEntityPracticeV3Invoice: {
      notifications: {
        seeLegalEntityInvoice: 'Generating bill in progress ...'
      }
    }
  }
};
